import React from "react";
import { Users, Briefcase } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const FLEET_IMAGES = [
  "https://images.unsplash.com/photo-1767749995450-7b63ab7cd4fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxibGFjayUyMGx1eHVyeSUyMHN1diUyMGRyaXZpbmd8ZW58MHx8fHwxNzgxNzIyODE4fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1700884520248-92092bd21e63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxibGFjayUyMGx1eHVyeSUyMHN1diUyMGRyaXZpbmd8ZW58MHx8fHwxNzgxNzIyODE4fDA&ixlib=rb-4.1.0&q=85",
];

const Fleet = () => {
  const { t } = useLang();

  return (
    <section
      id="fleet"
      data-testid="fleet-section"
      className="py-24 sm:py-32 bg-[#1A1F24] text-[#F9F6F0]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center mb-16">
          <div className="lg:col-span-5">
            <p className="text-[#C6A87C] text-xs uppercase tracking-[0.3em] mb-4">
              {t.fleet.eyebrow}
            </p>
            <h2 className="font-serif text-4xl sm:text-5xl tracking-tight mb-6">
              {t.fleet.title}
            </h2>
            <p className="text-[#A0AEC0] leading-relaxed">
              {t.fleet.desc}
            </p>
          </div>
          <div className="lg:col-span-7 grid grid-cols-2 gap-4">
            {FLEET_IMAGES.map((src) => (
              <div key={src} className="aspect-[4/5] overflow-hidden group">
                <img
                  src={src}
                  alt="Fleet vehicle"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10">
          {t.fleet.vehicles.map((v) => (
            <div
              key={v.name}
              data-testid={`fleet-vehicle-${v.name}`}
              className="bg-[#1A1F24] p-8 sm:p-10"
            >
              <div className="text-[#C6A87C] text-xs uppercase tracking-[0.3em] mb-3">
                {v.name}
              </div>
              <h3 className="font-serif text-2xl mb-6">{v.name}</h3>
              <div className="space-y-3 text-sm text-[#A0AEC0]">
                <div className="flex items-center gap-3">
                  <Users className="w-4 h-4 text-[#C6A87C]" />
                  <span>{v.capacity}</span>
                </div>
                <div className="flex items-center gap-3">
                  <Briefcase className="w-4 h-4 text-[#C6A87C]" />
                  <span>{v.luggage}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Fleet;
